export default __webpack_public_path__ + "static/media/CircleAlex.8843ede6.svg";